import React, { useEffect, useRef } from 'react';
import rakesh_rathi from '../../assets/team/WhatsApp Image 2023-06-16 at 12.28.37.jpeg';
import pravin_patil from '../../assets/team/WhatsApp Image 2023-06-16 at 13.06.13.jpeg';
import linkedin from '../../assets/images/linkedin.png';

import Tushar_Balakshe from '../../assets/team/Tushar Balakshe.jpeg';
import gaurav from '../../assets/team/Gaurav sirr.jpeg';
import op from '../../assets/team/OP SIRR.jpg';
import chetan from '../../assets/team/WhatsApp Image 2023-06-16 at 12.36.49 (1).jpeg';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const teamMembers = [
  {
    name: 'Mr. Rakesh Rathi',
    position: 'MANAGING DIRECTOR',
    image: rakesh_rathi,
    bio: `Rakesh Rathi, Managing Director and CEO of Parthiv Group, is a
            visionary leader. With 22 years of experience as a Chartered
            Accountant, he has successfully served as CFO at renowned companies
            like Smaaash Entertainment, Essel World, and more. His expertise
            spans finance, strategic planning, and managing the entire gamut of
            Finance and Accounts activities. Under his guidance, Parthiv Group
            has expanded into diverse industries, including finance, NBFCs, F&B,
            interior and furniture manufacturing.`,
  },
  {
    name: 'Mr. Gaurav Palliwal',
    position: 'CHIEF EXECUTIVE OFFICER',
    image: gaurav,
    bio: ` Gaurav Palliwal has 15+ years of experience in Channel/Dealership
            Management, Business Development, Key Account Management, and Team
            Management. Worked with reputable insurance and broking companies,
            achieving outstanding revenue growth and exceeding targets.
            Expertise in prospect mapping, market analysis, and team
            collaboration. As CEO of Efficient Insurance Brokers, focused on
            establishing a market-leading legacy, expanding geographically with
            diverse lines of business for sustained success.`,
  },
  {
    name: 'Mr. TUSHAR BALAKSHE',
    position: 'National Head',
    image: Tushar_Balakshe,
    bio: ` Tushar Balakshe is a BA graduate with 10+ years of experience in the
            insurance industry. Worked at Landmark Insurance Brokers, Reliable
            Insurance Services, and Bajaj Allianz GIC Ltd. Proficient in team
            management, marketing, business development, and client servicing.
            Excels as an insurance consultant, specializing in maintaining
            strong client relationships at Insure Efficient.`,
  },
];

const FirstTab = () => {
  const sectionsRef = useRef([]);

  useEffect(() => {
    sectionsRef.current.forEach((section, index) => {
      // Alternate between left and right for each section
      const direction = index % 2 === 0 ? '-100%' : '100%';

      gsap.from(section, {
        x: direction,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 80%', // Start animation when 80% of the section is in view
          end: 'bottom 20%', // End animation when 20% of the section is in view
          once: true,
        },
      });
    });

    // Clean up when component unmounts
    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    };
  }, []);

  return (
    <div className="flex flex-col w-full pt-4 font-sans">
      {teamMembers.map((member, index) => (
        <div
          key={index}
          className={`flex flex-col ${
            index % 2 === 0
              ? 'md:grid md:grid-cols-[2fr_1fr]'
              : 'md:grid md:grid-cols-[1fr_2fr]'
          } mt-10 items-center md:gap-12`}
          ref={(el) => (sectionsRef.current[index] = el)}
        >
          <div
            className={`relative w-full flex justify-center ${
              index % 2 === 0 ? 'md:order-2' : ''
            }`}
          >
            <img
              src={member.image}
              alt={`${member.name}`}
              className="w-48 h-60 md:w-60 md:h-72 rounded-2xl object-cover shadow-lg"
            />
          </div>
          <div className="w-full md:pr-8 md:ml-24 xl:ml-0 text-center md:text-left">
            <div className="flex justify-center md:justify-start">
              <h3 className="text-2xl font-semibold text-[#1976D2] uppercase">
                {member.name}
              </h3>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <img
                  src={linkedin}
                  alt={`${member.name} LinkedIn`}
                  className="w-6 h-6 ml-4"
                />
              </a>
            </div>
            <h5 className="text-sm font-bold uppercase pt-1 text-slate-600">
              {member.position}
            </h5>
            <p className="text-base font-normal font-sans pt-2 text-slate-500 leading-6">
              {member.bio}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FirstTab;
